export enum CvtConcern {
    Drivability = 'drivability',
    Dtc = 'dtc',
    NoiseOrLeak = 'noiseOrLeak',
}

export type CvtConcernOption = {
    title: string;
    value: CvtConcern;
};

export type CvtPrimaryConcernsModalContent = 'cvtDiagnosticNotRequired' | 'runCvtDiagnostic' | 'selectConcerns';
